import example from './example';

export default {
	example: example
};



// WEBPACK FOOTER //
// ./src/script/model/index.js